import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./users";
import loginReducer from "./login";
import previousUsersReducer from "./previousUsers";
import accountingTableReducer from "./accountingTable";
import accountTypesReducer from "./accountTypes";
import portalUsersReducer from "./portalUsers";
import selectedScreenReducer from "./selectedScreen";
import scrollReducer from "./scrollPosition";
import agentReducer from "./agents";
import formReducer from "./customForms";
import constantsReducer from "./constants";
import configReducer from "./config";
import operatorReducer from "./operator";
import uiReducer from "./uiSlice";

const saveConstantsToSessionStorage = (constants) => {
  try {
    const serializedState = JSON.stringify(constants);
    sessionStorage.setItem("constants", serializedState);
  } catch (e) {
    console.error("Could not save constants to session storage", e);
  }
};

const loadConstantsFromSessionStorage = () => {
  try {
    const serializedState = sessionStorage.getItem("constants");
    if (serializedState === null) return undefined;
    return JSON.parse(serializedState);
  } catch (e) {
    console.error("Could not load constants from session storage", e);
    return undefined;
  }
};
export const store = configureStore({
  reducer: {
    usersList: userReducer,
    agentList: agentReducer,
    operatorsList: operatorReducer,
    login: loginReducer,
    previousUsers: previousUsersReducer,
    accountingTable: accountingTableReducer,
    accountTypes: accountTypesReducer,
    portalUsers: portalUsersReducer,
    selectedScreen: selectedScreenReducer,
    scroll: scrollReducer,
    customForms: formReducer,
    constants: constantsReducer,
    config: configReducer,
    ui: uiReducer
  },
  preloadedState: {
    constants: loadConstantsFromSessionStorage(), // Load only constants slice from sessionstorage now
  },
  devTools: process.env.NODE_ENV !== "production",
});

// Subscribe to store updates to save the constants slice to sessionstorage
store.subscribe(() => {
  const currentState = store.getState();
  saveConstantsToSessionStorage(currentState.constants);
});
